class INTENT.utils.CreativesValidation
  @validateForm: () =>
    errorText = ''
    if $("#kktu_codes").length > 0 && ($("#kktu_codes").val() == null || $("#kktu_codes").val().length == 0)
      errorText = errorText + __('creative.validate.error_verificator.ord.ktu_codes.error')
      #если поле только для чтения(значит это не админ), то нужно добавить еще текст.
      if $("#kktu_codes").is('[readonly]')
        errorText = errorText + '<br>' + __('creative.validate.error_verificator.ord.ktu_codes.error.not_admin')
    return errorText
